<template>
  <div
    id="conversations"
    class="no-shrink">
    <ConversationHeader
      v-model="searchQuery"
      @filter="filterChanged" />
    <b-overlay
      class="greedy basic-height"
      :show="show"
      rounded="sm">
      <div slot="overlay">
        <Spinner/>
      </div>

      <ConversationsTmp
        v-show="isObject(searchQuery) && searchQuery.type === 'conversationSearch'"
        :search-query="searchQuery.conversationSearch"
        :scope="searchQuery.scope"
        :filter="filter" />
      <ContactSearch
        v-if="isObject(searchQuery) && searchQuery.type === 'contactSearch'"
        :search-query="searchQuery.contactSearch"
        :branch-id="searchQuery.branchId" />
    </b-overlay>
  </div>
</template>

<script>
import ConversationHeader from './partials/ConversationHeader';
import Spinner from '../../common/Spinner';
import ConversationsTmp from './ConversationsTmp';
import ContactSearch from '@/components/business/contacts/partials/ContactSearch';

export default {
  name: 'Conversations',
  components: {
    ConversationHeader,
    Spinner,
    ConversationsTmp,
    ContactSearch,
  },
  directives: {},
  data() {
    return {
      show: false,
      searchQuery: {
        type: 'conversationSearch',
      },
      filter: {},
    };
  },
  methods: {
    filterChanged(filters) {
      this.filter = filters;
    },
  },
};
</script>

<style lang="scss">
#conversations {
  width: 339px;
  background-color: white;
  display: flex;
  flex-direction: column;
  box-shadow: 1px 0 $greyBorderSecondary;
  // z-index: 900;
  overflow: hidden;

  /* Gives the initial height to the element so it doesn't overflow. */
  .basic-height {
    height: 10px;
  }
}
</style>
